// extracted by mini-css-extract-plugin
export default {"productDescription":"G_-z","featuredDescription":"H_-z","description":"I_-z","more":"J_-z","descriptionSku":"K_-z"};